import React from "react";
import { Link } from "react-router-dom";

// Shared "About Ask Nauticus" disclosure (used on /ask and the SBA landing page).
export const AskAboutCard = ({ testid = "ask-disclosure-card", className = "" }) => (
  <div className={`rounded-xl border border-[#E7E4DB] bg-white p-4 text-[11px] leading-relaxed text-[#5B6670] ${className}`} data-testid={testid}>
    <p className="font-semibold text-[#0B192C] mb-1">About Ask Nauticus</p>
    Ask Nauticus is an AI-assisted informational experience from Nauticus, a product of Navillus
    Technologies, an independent technology platform. Answers about general Medicare topics cite
    Medicare.gov and CMS information, shown with each answer.{" "}
    <span data-testid={`${testid}-nonaffiliation`}>Nauticus is not affiliated with or endorsed by the U.S. government or the federal Medicare program.</span>{" "}
    We do not guess plan-specific facts (prices, benefits, formularies, or networks). Your details
    are saved to a household only when you ask, over an encrypted connection. A licensed insurance agent is
    available if you request one. This is not insurance advice or an enrollment decision.
    <Link to="/privacy" className="mt-2 block font-semibold text-[#1E3E62] hover:underline" data-testid={`${testid}-privacy-link`}>
      How we protect your information →
    </Link>
  </div>
);
